import { h } from 'preact';

const Loader = () => (
    <dev class={`loading`}></dev>
);
export default Loader;